// TODO: Check if this is needed here
// This is required for IE (previously used as babel-polyfill, which is now deprecated)
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import elementClosest from 'element-closest'

// This is a IE11 fix that is needed for slate editor to work
// Slate editor is currently not used, but it might still be needed for something else
elementClosest(window)

/**
 * Add "intl" as polyfill to solve this error:
 * [React Intl] The `Intl` APIs must be available in the runtime, and do not appear to be built-in. An `Intl` polyfill should be loaded.
 * See: http://formatjs.io/guides/runtime-environments/
 */
if (!global.Intl) {
  global.Intl = require('intl')
}
if (!window.Intl) {
  window.Intl = require('intl')
}
